import React from 'react';
import MaterialCheckbox from '@mui/material/Checkbox';
import type {CheckboxProps as MaterialCheckboxProps} from '@mui/material/Checkbox';
import {styled} from '@mui/material/styles';

export type CheckboxProps = Omit<MaterialCheckboxProps,
'disableFocusRipple' |
'centerRipple' |
'disableTouchRipple' |
'focusRipple' |
'disableRipple' |
'TouchRippleProps' |
'color'
>;

const StyledCheckbox = styled(MaterialCheckbox)(({theme}) => ({
    height: '1.875rem',
    width: '2.125rem',
    marginLeft: theme.spacing(1),
    color: theme.tokens.FuelColorBorderDark,
    '&.Mui-focusVisible .MuiSvgIcon-root': {
        borderRadius: theme.shape.borderRadius,
        boxShadow: `inset 0 0 0 0.125rem ${theme.tokens.FuelColorFocused}`
    },
    '&:hover': {
        backgroundColor: 'transparent'
    },
    '&.Mui-checked:hover': {
        backgroundColor: 'transparent'
    },
    '&.MuiIconButton-edgeStart': {
        marginLeft: '-12px'
    },
    '&.MuiIconButton-edgeEnd': {
        marginRight: '-12px'
    },
    boxSizing: 'border-box',
    '&:not(.Mui-disabled).MuiCheckbox-indeterminate': {
        color: theme.tokens.FuelColorBackgroundInteractiveDefaultBase
    }
}));

export const Checkbox = React.forwardRef<any, CheckboxProps>(
    (
        {...props},
        ref
    ) => {
        return (
            <StyledCheckbox
                ref={ref}
                {...props}
            />
        );
    });

Checkbox.displayName = 'Checkbox';
